var UA = require('@dp/util-m-ua')();
var SocialRecord = require('@dp/util-record-friend').default;
var extend = require('./entries/util/extend');

require('./css/style.css');

var _setting = {
  enableSocialRecord: false,
  wxAutoConfig: true,
  wxLoadScript: true,
  hide: false, //隐藏分享
  envir: '' //分享环境
};

var instance;
var isInit = false;
var isLoading = false;
var cbQueue = [];
var ShareClass;
var dep;
var sRecord;

var patchShare4Type = function(envir, cb) {
  if (cb) {
    cbQueue.push(cb);
  }
  if (isLoading) {
    return;
  }else{
    isLoading = true;
  }
  envir = envir || UA.type;
  
  cb = function(shareConstructor, shareDep) {
    ShareClass = shareConstructor;
    dep = shareDep;
    isInit = true;
    cbQueue.forEach(function(callback) {
      callback(ShareClass, dep);
    });
    cbQueue = [];
  };
  
  //异步加载模块解析规则问题，导致需要把异步模块都加载进来
  if (envir === 'dpapp') {
    
    var _doTask = function(KNB) {
      require.ensure([],function(require) {
        var DPAppShare = require('./entries/dpapp_share');
        KNB.ready(function() {
          cb(DPAppShare, {KNB: KNB});
        });
      },'dpapp-share'); 
    };
    
    if (window.KNB) {
      _doTask(window.KNB);
    }else{
      require.ensure([],function(require) {
        var KNB = require('@dp/knb/bundle');
        _doTask(KNB);
      });  
    }
  }else if (envir === 'weixin') {
    // require.ensure([], function() {
      var loader = require('@dp/weixin-js-sdk-loader');
      loader.use(function(wx) {
          try {
            wx.miniProgram.getEnv(function(res) {
              if(res.miniprogram) {
                require.ensure([],function() {
                  var WXMinaShare = require('./entries/wxmina_share.js');
                  cb(WXMinaShare, {loader: loader});
                }, 'wxmina-share');
              } else {
                require.ensure([],function() {
                  var WXShare = require('./entries/wx_share.js');
                  cb(WXShare, {loader: loader});
                },'wx-share');
              }
            });
          } catch(e) {
            console.warn('wx API exception');
          }
      });
      
    // }, 'wx-loader');
  }else if (envir === 'qq') {
    require.ensure([],function(require) {
      var QQShare = require('./entries/qq_share');

      cb(QQShare,{});
    },'qq-share');
  }else if (envir === 'qqzone') {
    require.ensure([],function(require) {
      var QQZoneShare = require('./entries/qqzone_share');

      cb(QQZoneShare, {});

    },'qqzone-share');
  }else if(envir === 'mtgroup'){
    var isMTNB = false;
    if (UA.version < '7.6.0') {
      isMTNB = true;
    }

    var doTask = function() {
      var KNB = window.KNB;
      require.ensure([],function(require) {
        var MTShare = require('./entries/mt_share');
        KNB.ready(function() {
          cb(MTShare, {KNB: KNB, isMTNB: isMTNB});
        });
      },'mt-share'); 
    };
    if (window.KNB) {
      doTask();
    }else{
      require.ensure([],function(require) {
        window.KNB = require('@dp/knb/bundle');
        doTask();
      });    
    }
  }else if(envir === 'browser' || envir === 'ucweb'){
    require.ensure([],function(require) {
      
      var BrowserShare = require('./entries/browser_share');
      var $ = require('@dp/zepto');

      cb(BrowserShare, {$: $});

    },'browser-share');
  }
};

patchShare4Type();

var parseConfig = function(config, setting){
  if(!config) return config;
  if (config.image && config.image.indexOf('//') === 0) {
      config.image = window.location.protocol + config.image;
  }

  if(config.url && config.url.indexOf('//')===0){
    config.url = window.location.protocol + config.url;
  }

  if (!config.content) {
    config.content = '【'+config.title+'】' + config.desc;
  }

  if(setting && setting.enableSocialRecord){
    config.url = sRecord.changeUrl(config.url);  
  }

  return config;
};

var createShare = function(config, setting){
  setting = extend(_setting, setting, true);

  if(setting.enableSocialRecord){
    sRecord = new SocialRecord();
    sRecord.init();
  }
  config = parseConfig(config, setting);

  this.config = config;
  this.setting = setting;

  if (isInit) {
    instance = new ShareClass(config, setting, dep);
  }else{
    this._init();
  }
};

createShare.prototype = {
  _init: function(cb) {
    if (isInit) {
      cb && cb(instance);
    }else{
      var self = this;
      patchShare4Type(self.setting.env, function(ShareClass, dep) {
        instance = new ShareClass(self.config, self.setting, dep);
        cb && cb(instance);
      });      
    }

  },
  //由于分享模块是异步加载的，所以只能返回createShare的实例，并不能直接返回instance实例
  updateConfig: function(config) {
    var setting = this.setting;
    this._init(function() {
      instance.updateConfig(parseConfig(config, setting));
    });
  },
  trigger: function(config) {
    var setting = this.setting;
    this._init(function() {
      instance.trigger(parseConfig(config, setting));
    });
  },
  hide: function() {
    this._init(function() {
      instance.hide();
    });
  },
  remove: function() {
    this._init(function() {
      instance.remove();
    });
  }
};

createShare.CHANNEL = {
  WECHAT_FRIENDS: 0,
  WECHAT_TIMELINE: 1,
  QQ: 2,
  SMS: 3,
  WEIBO: 4,
  QZONE: 5,
  EMAIL: 6,
  COPY: 7,
  WEIBO_TECENT: 8
};

module.exports = createShare;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/util-m-share/bundle.js
// module id = 553
// module chunks = 1 12 14